var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.468 17.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436",
    transform: "translate(7958.786 -3940.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_",
    transform: "translate(-7958.786 3941.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_907_",
    d: "M97.568,48.839H86.994A1.293,1.293,0,0,1,85.7,47.544V32.794A1.293,1.293,0,0,1,86.994,31.5H97.568a1.293,1.293,0,0,1,1.294,1.294v14.75A1.293,1.293,0,0,1,97.568,48.839Z",
    transform: "translate(-85.7 -31.5)",
    fill: "#1c75a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_906_",
    d: "M98.8,59.66V45.282a.98.98,0,0,1,.982-.982h10.171a.98.98,0,0,1,.982.982V59.66a.98.98,0,0,1-.982.981H99.782A.985.985,0,0,1,98.8,59.66Z",
    transform: "translate(-98.288 -43.799)",
    fill: "#3da7e3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_905_",
    d: "M198.716,30.366V26.471L193.3,21.2h-4Z",
    transform: "translate(-8144.035 3919.695)",
    fill: "#175c8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_904_",
    d: "M189.3,21.2v.4h.415Z",
    transform: "translate(-8144.035 3919.695)",
    fill: "#1d4874"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_903_",
    d: "M422.3,248v.3h.3Z",
    transform: "translate(-8367.924 3701.764)",
    fill: "#1d4874"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M-4.97,0V-2.844h.84a1.317,1.317,0,0,1,.669.168,1.145,1.145,0,0,1,.452.477,1.513,1.513,0,0,1,.16.707v.143a1.506,1.506,0,0,1-.161.711,1.132,1.132,0,0,1-.459.473A1.378,1.378,0,0,1-4.151,0Zm.494-2.445V-.395h.322a.742.742,0,0,0,.6-.243,1.059,1.059,0,0,0,.212-.7v-.158a1.087,1.087,0,0,0-.2-.707.713.713,0,0,0-.584-.244Zm4.389,1.1a1.745,1.745,0,0,1-.145.733A1.093,1.093,0,0,1-.645-.13a1.136,1.136,0,0,1-.618.169A1.139,1.139,0,0,1-1.879-.13,1.11,1.11,0,0,1-2.3-.611a1.69,1.69,0,0,1-.149-.721v-.16A1.73,1.73,0,0,1-2.3-2.227a1.108,1.108,0,0,1,.416-.487,1.133,1.133,0,0,1,.616-.169,1.143,1.143,0,0,1,.616.167,1.094,1.094,0,0,1,.415.48,1.726,1.726,0,0,1,.148.729ZM-.581-1.5A1.243,1.243,0,0,0-.76-2.221a.585.585,0,0,0-.507-.252.583.583,0,0,0-.5.251,1.219,1.219,0,0,0-.185.71v.164a1.234,1.234,0,0,0,.183.725.588.588,0,0,0,.507.256.581.581,0,0,0,.5-.25,1.26,1.26,0,0,0,.177-.73Zm3.156.57a1.027,1.027,0,0,1-.336.71A1.145,1.145,0,0,1,1.46.039a1.109,1.109,0,0,1-.6-.161,1.058,1.058,0,0,1-.4-.458A1.653,1.653,0,0,1,.315-1.27v-.266a1.665,1.665,0,0,1,.143-.709,1.075,1.075,0,0,1,.409-.473,1.141,1.141,0,0,1,.616-.166,1.1,1.1,0,0,1,.758.255,1.065,1.065,0,0,1,.334.722H2.083A.7.7,0,0,0,1.9-2.349a.591.591,0,0,0-.421-.136.577.577,0,0,0-.5.236,1.177,1.177,0,0,0-.177.691v.252a1.249,1.249,0,0,0,.165.7.548.548,0,0,0,.483.242A.639.639,0,0,0,1.9-.49a.682.682,0,0,0,.186-.436ZM4-1.816l.6-1.027h.57L4.3-1.434,5.183,0H4.606L4-1.043,3.382,0H2.808l.881-1.434-.861-1.41H3.4Z",
    transform: "translate(-7952 3955)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.33a55e33146acab5b1a52dd45487224d.svg";
export { ForwardRef as ReactComponent };